import { Div2Floor } from "../utils/Div2Floor";
import { enumButtonLabelPosition, enumElementDrawStates } from "../constants";
import { QBasicButton } from "./QBasicButton";
import { Globals } from "./Globals";
import { SetCtxFont } from "../utils/SetCtxFont";

export class QAnimateTextButton extends QBasicButton {
  constructor() {
    super();
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    var themeMode = Globals._themeMode;
    var drawState = this.GetDrawState();
    var txtHOffset = Div2Floor(this.fWidth);
    var txtFillStyle = this.fTxtFillStyle;

    switch (drawState) {
      case enumElementDrawStates.Disabled:
        txtFillStyle = themeMode.text.disabled;
        break;
    }

    ctx.fillStyle = txtFillStyle;
    var fontString = this.fFontString != null ? this.fFontString : "12px Arial";

    if (this.fIsActive || this.fSelected || drawState === enumElementDrawStates.Hover)
      fontString = "bold " + fontString;

    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";

    var txt = this.fLabel;
    var labelText = txt;
    var xPos, yPos;
    switch (this.fLabelPosition) {
      case enumButtonLabelPosition.below:
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight - 4;
        break;
      case enumButtonLabelPosition.center:
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.left:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + labelW / 2 + txtHIndent + this.fLabelInset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
    }

    SetCtxFont(ctx, fontString);
    ctx.fillText(labelText, xPos, yPos, this.GetWidth());
    var labelW = this.MeasureLabel();
    if (this.fIsActive || this.fSelected) {
      ctx.lineWidth = 3;
      ctx.strokeStyle = this.fUnderlineColor;
      ctx.fillStyle = this.fUnderlineColor;
      var lineBufferX = this.GetDrawState() === enumElementDrawStates.Hover ? 4 : 2;

      var ey = this.fVertOffset + this.fHeight - 0.5;

      var sx = this.fHorzOffset + this.fWidth / 2 - labelW / 2 - 2 * lineBufferX;
      var ex = sx + labelW + 4 * lineBufferX;

      ctx.beginPath();
      ctx.moveTo(sx, ey);
      ctx.lineTo(ex, ey);
      ctx.stroke();
      ctx.closePath();
    }
    ctx.restore();
  }

  DrawPad(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    if (this.fStdFillColor) {
      ctx.fillStyle = this.fStdFillColor;
      ctx.fill(this.fClippedRegion);
    }
    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    this.DrawPad(drawBuffer);
    this.DrawLabel(drawBuffer);
  }
}
